import { render, staticRenderFns } from "./RepairForm.vue?vue&type=template&id=5b0ab461&"
import script from "./RepairForm.vue?vue&type=script&lang=js&"
export * from "./RepairForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports